module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[100]221.3bb4109.woff2";